import { render, staticRenderFns } from "./ProyeccionHidrocarburosForm.vue?vue&type=template&id=61c6d038"
import script from "./ProyeccionHidrocarburosForm.vue?vue&type=script&lang=js"
export * from "./ProyeccionHidrocarburosForm.vue?vue&type=script&lang=js"
import style0 from "./ProyeccionHidrocarburosForm.vue?vue&type=style&index=0&id=61c6d038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports